import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendNoClientAudioCallAndSms = async ({ fromNumber, toNumber }: { fromNumber: string; toNumber: string }) => {
  const response = await mutationExecute({
    variables: {
      fromNumber,
      toNumber,
    },
    mutation: graphql(`
      mutation SendNoClientAudioCallAndSms($fromNumber: String!, $toNumber: String!) {
        sendNoClientAudioCallAndSms(fromNumber: $fromNumber, toNumber: $toNumber)
      }
    `),
  });

  return response.data?.sendNoClientAudioCallAndSms ?? false;
};
